import {DSListTile} from "@cdx/ds";
import {
  CardPropChangeOverlayForChild,
  NewCardPropChangeOverlayForChild,
} from "../RichTextarea/Lexical/CardPropChangeForChild";
import {CardPropChangeKey} from "../RichTextarea/Lexical/CardPropChangeOverlay";
import {ComponentProps, ReactNode} from "react";
import {
  NewWorkflowItemPropChangeOverlayForChild,
  WorkflowPropChangeOverlayForChild,
} from "../../features/workflows/WorkflowPropChangeForChild";
import {DefaultCardPropChangeOverlayForChild} from "../../features/workflows/DefaultCardPropChangeForChild";

export const NoneButton = (props: Omit<ComponentProps<typeof DSListTile>, "children" | "size">) => (
  <DSListTile size="smButton" {...props}>
    None
  </DSListTile>
);

type OverlayProps = {
  card: any;
  onChange?: (arg: any) => unknown; // only relevant for new cards
  availableShortcuts?: CardPropChangeKey[];
  children: ReactNode;
  cardContainerKey: string;
  getChildProps?: (open: boolean) => any;
  onClick?: (e: any) => void;
  type?: string;
};

export const SharedPropChangeOverlayForChild = ({
  card,
  onChange,
  availableShortcuts,
  children,
  cardContainerKey,
  getChildProps,
  onClick,
  type,
}: OverlayProps) => {
  switch (type) {
    case "BIG_DEFAULT_CARD": {
      return (
        <DefaultCardPropChangeOverlayForChild
          deck={card.deck}
          onClick={onClick}
          cardContainerKey={cardContainerKey}
          availableShortcuts={availableShortcuts}
          getChildProps={getChildProps}
        >
          {children}
        </DefaultCardPropChangeOverlayForChild>
      );
    }
    case "BIG_WORKFLOW_ITEM": {
      return card.id.startsWith("new") ? (
        <NewWorkflowItemPropChangeOverlayForChild
          item={card}
          onChange={onChange!}
          availableShortcuts={availableShortcuts}
          getChildProps={getChildProps}
          onClick={onClick}
        >
          {children}
        </NewWorkflowItemPropChangeOverlayForChild>
      ) : (
        <WorkflowPropChangeOverlayForChild
          itemId={card.id}
          cardContainerKey={cardContainerKey}
          availableShortcuts={availableShortcuts}
          getChildProps={getChildProps}
          onClick={onClick}
        >
          {children}
        </WorkflowPropChangeOverlayForChild>
      );
    }
    default: {
      return card.id.startsWith("new") ? (
        <NewCardPropChangeOverlayForChild
          card={card}
          onChange={onChange!}
          availableShortcuts={availableShortcuts}
          getChildProps={getChildProps}
          onClick={onClick}
        >
          {children}
        </NewCardPropChangeOverlayForChild>
      ) : (
        <CardPropChangeOverlayForChild
          cardId={card.id}
          cardContainerKey={cardContainerKey}
          availableShortcuts={availableShortcuts}
          getChildProps={getChildProps}
          onClick={onClick}
        >
          {children}
        </CardPropChangeOverlayForChild>
      );
    }
  }
};
